module.exports = __webpack_public_path__ + "img/banner.0920a61f.png";